module.exports = __webpack_public_path__ + "icon-search.svg?0c1468d287989438b54f2720718ec9c1";